import type { AggregateResult } from '../weldParameterAggregator'
import type { CwCcwMode, UploadFormat } from './types'

export interface WeldParamsUploadSection {
  source: 'upload'
  uploadFormat: UploadFormat
  aggregate: AggregateResult
  passMappings: Record<string, string>
  sourceFilename: string
  sourceFilenames: string[]
  uploadedAt: string
  cwCcwMode?: CwCcwMode
}

export function compactSourceFilename(filenames: string[]): string {
  if (filenames.length === 0) return ''
  if (filenames.length === 1) return filenames[0]
  return `${filenames[0]} + ${filenames.length - 1} more`
}

export function buildWeldParamsUploadSection(input: {
  aggregate: AggregateResult
  passMappings: Record<string, string>
  sourceFilenames: string[]
  uploadedAt: string
  uploadFormat: UploadFormat
  cwCcwMode?: CwCcwMode
}): WeldParamsUploadSection {
  return {
    source: 'upload',
    uploadFormat: input.uploadFormat,
    aggregate: input.aggregate,
    passMappings: input.passMappings,
    sourceFilename: compactSourceFilename(input.sourceFilenames),
    sourceFilenames: input.sourceFilenames,
    uploadedAt: input.uploadedAt,
    ...(input.cwCcwMode ? { cwCcwMode: input.cwCcwMode } : {})
  }
}
